(function() {
  var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
templates['column-collection.hbs'] = template({"1":function(depth0,helpers,partials,data) {
  var stack1, lambda=this.lambda, escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing;
  return "      <li class=\"row\" data-id=\""
    + escapeExpression(lambda((depth0 != null ? depth0.id : depth0), depth0))
    + "\" data-self=\""
    + escapeExpression(lambda(((stack1 = (depth0 != null ? depth0.links : depth0)) != null ? stack1.self : stack1), depth0))
    + "\">"
    + escapeExpression(((helpers.displayName || (depth0 && depth0.displayName) || helperMissing).call(depth0, depth0, {"name":"displayName","hash":{},"data":data})))
    + "</li>\n";
},"3":function(depth0,helpers,partials,data) {
  return "      <div class=\"muted\"><i>None</i></div>\n";
  },"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var stack1, buffer = "<div class=\"column-header\">Collection</div>\n<ul class=\"column-body\">\n  <li>\n    <div class=\"section-header\">&#9660;Links</div>\n";
  stack1 = this.invokePartial(partials['column-links.hbs'], '    ', 'column-links.hbs', depth0, undefined, helpers, partials, data);
  if (stack1 != null) { buffer += stack1; }
  buffer += "  </li>\n\n  <li>\n    <div class=\"section-header\">&#9660;Data</div>\n    <ul class=\"collection-data\">\n";
  stack1 = helpers.each.call(depth0, (depth0 != null ? depth0.data : depth0), {"name":"each","hash":{},"fn":this.program(1, data),"inverse":this.program(3, data),"data":data});
  if (stack1 != null) { buffer += stack1; }
  return buffer + "    </ul>\n  </li>\n</ul>\n";
},"usePartial":true,"useData":true});
})();
